import React from 'react';

import LogOutLink from 'common/components/LogOutLink';
import { trackLogOutLink } from '../tracking';
import { TranslatedMessage } from 'common/components/Intl';
import * as m from '../messages';

export default class AVLogOutLink extends React.Component {
  render() {
    return (
      <p className="text--small logout">
        <LogOutLink onClick={trackLogOutLink}>
          <TranslatedMessage id={m.LOGOUT} />
        </LogOutLink>
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/LogOutLink.js